import { render } from "./Q0-Home.vue?vue&type=template&id=7ab042dc"
import script from "./Q0-Home.vue?vue&type=script&lang=js"
export * from "./Q0-Home.vue?vue&type=script&lang=js"

import "./Q0-Home.vue?vue&type=style&index=0&id=7ab042dc&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__